module.exports = __webpack_public_path__ + "static/media/comingSoonCalendar.ba4c979c.svg";